/** SAAS-1 · 构建注入的版本号；测试 / 没注入时显示 dev。 */
export function buildVersion(): string {
  return typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "dev";
}
